export const OHL = {
    name: 'DV 1229B RP ĐERDAP 2 - HE ĐERDAP 2, blok 4',
    voltage: '110',
    regionCode: 'BR',
    stanice: [{name: 'ĐERDAP 2', position: {lat: 44.2983, lng: 22.565}}],
    stubovi: [
        { index: 1, name: 'P', lat: 44.2982 , lng: 22.5651, sys: 1, portal: true },
        { index: 2, name: '10', lat: 44.2986 , lng: 22.5653, sys: 2},
        { index: 3, name: '9', lat: 44.301 , lng: 22.566, sys: 2},
        { index: 4, name: '8', lat: 44.304 , lng: 22.5669, sys: 2},
        { index: 5, name: '7', lat: 44.3055 , lng: 22.5674, sys: 2},
        { index: 6, name: '6', lat: 44.3069 , lng: 22.5671, sys: 1},
        { index: 7, name: 'P.B.-4', lat: 44.3069 , lng: 22.5672, sys: 1, portal: true }
    ],
    rasponi: [
        { name: 'P - 10', position: [{ lat: 44.2982 , lng: 22.5651 }, { lat: 44.2986 , lng: 22.5653 }] },
        { name: '10 - 9', position: [{ lat: 44.2986 , lng: 22.5653 }, { lat: 44.301 , lng: 22.566 }] },
        { name: '9 - 8', position: [{ lat: 44.301 , lng: 22.566 }, { lat: 44.304 , lng: 22.5669 }] },
        { name: '8 - 7', position: [{ lat: 44.304 , lng: 22.5669 }, { lat: 44.3055 , lng: 22.5674 }] },
        { name: '7 - 6', position: [{ lat: 44.3055 , lng: 22.5674 }, { lat: 44.3069 , lng: 22.5671 }] },
        { name: '6 - P.B.-4', position: [{ lat: 44.3069 , lng: 22.5671 }, { lat: 44.3069 , lng: 22.5672 }] }
    ]
}
